module.exports = __webpack_public_path__ + "img/ywAward-c.08074410.png";